type FieldLabelProps = {
  children: React.ReactNode;
};

export const FieldLabel = ({ children }: FieldLabelProps) => (
  <div className="t-text-body-sm t-text-neutral-50">{children}</div>
);
